import CarteiraConstans from "../../infra/data/carteiraConstants"
import { CustomGet, Get, GetSSE, Post } from "domain/infra/data/api"
import { DepositoPixRequest } from "../../types/deposito/depostioPixRequest"
import ValidationResult from "domain/types/global/validationResult"
import { CalcularImpostoRequest } from "../../types/deposito/calcularImpostoRequest"
import { CalcularImpostoResponse } from "../../types/deposito/calcularImpostoResponse"
import { DepositoDebitoRequest } from "../../types/deposito/depositoDebitoRequest"
import { DepositoCreditoRequest } from "../../types/deposito/depositoCreditoRequest"
import { DepositoBoletoRequest } from "../../types/deposito/depositoBoletoRequest"
import { DepositoPixResponse } from "../../types/deposito/depositoPixResponse"
import { DepositoBoletoResponse } from "../../types/deposito/depositoBoletoResponse"
import { ResponseValid } from "domain/utils/ReactUtils"
import { toast } from 'react-toastify';
import { BoletoResponse } from "../../types/boleto/boletoResponse"
import { _UserData, UserDataBaseEnum } from "base/src/infra/storage/localStorage"

export class DepositoService {
  constructor() {
    //super()
  }

  async DepositoPix(data: DepositoPixRequest, carteiraId: number): Promise<DepositoPixResponse | Error> {
    return await Post(CarteiraConstans.apiCarteira.carteira.depositoPix(carteiraId), data)
  }

  async PixCheckSSE(carteiraId: number, codigoInterno: string, dispatchName: string): Promise<string | Error> {
    return await GetSSE(`${CarteiraConstans.apiCarteira.carteira.pixCheckSSE(carteiraId)}?codigoInterno=${codigoInterno}`, dispatchName)
  }

  async SimularPix_DEV(carteiraId: number, codigoInterno: string): Promise<string | Error> {
    return await Get(`${CarteiraConstans.apiCarteira.carteira.simularPix_DEV(carteiraId)}?codigoInterno=${codigoInterno}`)
  }

  async SimularBoleto_DEV(carteiraId: number, codigoInterno: string): Promise<string | Error> {
    return await Get(`${CarteiraConstans.apiCarteira.carteira.simularBoleto_DEV(carteiraId)}?codigoInterno=${codigoInterno}`)
  }

  async DepositoDebito(data: DepositoDebitoRequest, carteiraId: number): Promise<ValidationResult | Error> {
    return await Post(CarteiraConstans.apiCarteira.carteira.depositoDebito(carteiraId), data)
  }

  async DepositoCredito(data: DepositoCreditoRequest, carteiraId: number): Promise<ValidationResult | Error> {
    return await Post(CarteiraConstans.apiCarteira.carteira.depositoCredito(carteiraId), data)
  }

  // async DepositoBoleto(data: DepositoBoletoRequest, carteiraId: number): Promise<DepositoBoletoResponse | Error> {
  //   return await Post(CarteiraConstans.apiCarteira.carteira.depositoBoleto(carteiraId), {Valor: data.Valor});
  // }

  async DepositoBoleto(data: DepositoBoletoRequest, carteiraId: number, dispatchName: string): Promise<DepositoBoletoResponse | Error> {
    return await Post(CarteiraConstans.apiCarteira.carteira.depositoBoleto(carteiraId), data, dispatchName);
  }

  async GetBoletoSemelhante(carteiraId: number, valor: number): Promise<DepositoBoletoResponse | Error> {
     return await Get(CarteiraConstans.apiCarteira.carteira.GetBoletoSemelhante(carteiraId, valor));
  }

  async GetBoletos(carteiraId: number, dispatchName: string): Promise<BoletoResponse | Error> {
    // return await Get(`https://localhost:7244/Carteira/${8}/Deposito/Boletos`, dispatchName); // Desgraça dos endpoint fica me jogando pro publicado
    return await Get(CarteiraConstans.apiCarteira.carteira.getBoletos(carteiraId), dispatchName);
  }

  async GerarBoleto(data: DepositoBoletoResponse): Promise<string | undefined | Error> {
    try {
      const paymentResponse = await CustomGet(data.PaymentUrl,
        {
          responseType: 'blob',
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': `${_UserData.Get(UserDataBaseEnum.Token)}`,
          }
        }
      ) as Blob | Error;
      if (ResponseValid(paymentResponse)) {
        // paymentResponse = paymentResponse as Blob;
        // const url = URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
        const url = URL.createObjectURL(paymentResponse as Blob);
        return this.AbrirBoleto(url);
      }

      return { message: "Problema ao abrir o boleto " } as Error;

    } catch (error) {
      return { message: "Problema ao gerar o boleto! " + error } as Error;
    }
  }

  AbrirBoleto(url: string): string | undefined {
    const newWindow = window.open(url, "_blank");
    if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
      toast("O boleto não pôde ser aberto automaticamente. Por favor, permita popups para este site.");
      return url
    }
    return undefined;
  }

  async CalcularImposto(data: CalcularImpostoRequest, carteiraId: number, dispatchName: string): Promise<CalcularImpostoResponse[] | Error> {
    return await Get(`${CarteiraConstans.apiCarteira.carteira.calcularImposto(carteiraId)}?valor=${data.Valor}&transacaoTipo=${data.TransacaoTipo}&parcelas=${data.Parcelas}`, dispatchName)
  }

  async GetMeioPagamento(carteiraId: number, dispatchName: string): Promise<CalcularImpostoResponse | Error> {
    return await Get(CarteiraConstans.apiCarteira.carteira.getMeioPagamento(carteiraId), dispatchName);
  }
}
